import React from "react";
import "./loader.css";

const Loader = () => {
  return (
    <div className="gooey">
      <span className="dot" />
      <div className="dots">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};

export default Loader;
